export function Logo({ compact = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div className="relative h-9 w-9 shrink-0 rounded-lg border border-[color:var(--hairline)] bg-[hsl(220_14%_6%)] flex items-center justify-center elev-1">
        <span className="font-display text-[17px] leading-none text-primary">KE</span>
        <span className="absolute -bottom-px left-2 right-2 h-px bg-primary/70" />
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className="font-display text-[17px] text-foreground">Kalkulator Eddy</div>
          <div className="text-[10px] tracking-[0.22em] uppercase text-[hsl(43_45%_60%)]">kalkulatoreddy.com</div>
        </div>
      )}
    </div>
  );
}

export function Footer({ className = "" }) {
  return (
    <footer
      className={`border-t border-border px-4 sm:px-6 lg:px-8 h-11 flex items-center justify-between text-xs text-muted-foreground ${className}`}
      data-testid="app-footer"
    >
      <span>
        Copyright © {new Date().getFullYear()} <span className="text-[hsl(43_60%_64%)]">Eddy Yansen</span>. All rights reserved.
      </span>
      <span className="hidden sm:inline tracking-wide">kalkulatoreddy.com</span>
    </footer>
  );
}
